/**
 * @generated SignedSource<<8e660484dfbadb94fb7bec9eb9bec307>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type VisibilityStatus = "ALL" | "NONE" | "QUALIFYING";
export type GuestPlayerRateDisplayQuery$variables = {
  membershipTypeId?: string | null | undefined;
  nonPlayingHost: boolean;
  timeSlotId: string;
};
export type GuestPlayerRateDisplayQuery$data = {
  readonly node: {
    readonly playerRates?: ReadonlyArray<{
      readonly rate: {
        readonly appliesToMembershipType: boolean | null | undefined;
        readonly code: string;
        readonly id: string;
        readonly name: string;
        readonly visibility: VisibilityStatus;
      };
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type GuestPlayerRateDisplayQuery = {
  response: GuestPlayerRateDisplayQuery$data;
  variables: GuestPlayerRateDisplayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nonPlayingHost"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "timeSlotId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "timeSlotId"
  }
],
v4 = {
  "kind": "Variable",
  "name": "membershipTypeId",
  "variableName": "membershipTypeId"
},
v5 = [
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "nonPlayingHost",
    "variableName": "nonPlayingHost"
  },
  {
    "kind": "Literal",
    "name": "type",
    "value": "GUEST"
  },
  {
    "kind": "Variable",
    "name": "visibleToMembershipTypeId",
    "variableName": "membershipTypeId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": [
    (v4/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "appliesToMembershipType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GuestPlayerRateDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "SlotRate",
                "kind": "LinkedField",
                "name": "playerRates",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "rate",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Slot",
            "abstractKey": "__isSlot"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "GuestPlayerRateDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "SlotRate",
                "kind": "LinkedField",
                "name": "playerRates",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "rate",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Slot",
            "abstractKey": "__isSlot"
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a76db86f57d388ea98d434c069adf919",
    "id": null,
    "metadata": {},
    "name": "GuestPlayerRateDisplayQuery",
    "operationKind": "query",
    "text": "query GuestPlayerRateDisplayQuery(\n  $timeSlotId: ID!\n  $membershipTypeId: ID\n  $nonPlayingHost: Boolean!\n) {\n  node(id: $timeSlotId) {\n    __typename\n    ... on Slot {\n      __isSlot: __typename\n      playerRates(type: GUEST, membershipTypeId: $membershipTypeId, nonPlayingHost: $nonPlayingHost, visibleToMembershipTypeId: $membershipTypeId) {\n        rate {\n          __typename\n          id\n          name\n          code\n          visibility\n          appliesToMembershipType(membershipTypeId: $membershipTypeId)\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "38009b54656cdaf5a8386b942e91a346";

export default node;
